import { TableContainer } from '@mui/material';

import { GDMTableContainerComponent } from './GDMTableContainer.type';

/* TODO: Implement component using GDM default design */
const GDMTableContainer: GDMTableContainerComponent = props => <TableContainer {...props} />;

export default GDMTableContainer;
